import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';

export default function WhyNowSection() {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <section id="why-now" className="relative py-24 sm:py-32 px-6 sm:px-12 lg:px-24" data-testid="why-now-section">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#161A16]/40 to-transparent pointer-events-none" />

      <div className="relative max-w-5xl mx-auto">
        <motion.div
          ref={sectionRef}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium">
            {t('whyNow.heading')}{' '}
            <span className="text-[#BDD6B5]">{t('whyNow.headingGreen')}</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-white/78 max-w-3xl leading-relaxed">
            {t('whyNow.body')}
          </p>
        </motion.div>

        {/* Stat + body callout */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="glass-card p-8 sm:p-10 flex flex-col sm:flex-row items-center gap-8"
          data-testid="why-now-stat"
        >
          <div className="shrink-0 text-center sm:text-left">
            <span className="text-4xl sm:text-5xl font-light text-[#BDD6B5] tracking-tight">
              {t('whyNow.stat')}
            </span>
            <p className="text-xs text-white/35 mt-1.5 font-mono tracking-wide">
              {t('whyNow.statLabel')}
            </p>
          </div>

          <div className="w-px h-12 bg-[#3D5638]/30 hidden sm:block shrink-0" />

          <p className="text-sm text-white/72 leading-relaxed">
            {t('whyNow.statBody')}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
